// extracted by mini-css-extract-plugin
module.exports = {"component":"StandardContent_component__2qCGn"};